import { cn } from "@/lib/utils";
import { vehicleStatusConfig, type VehicleStatus } from "@/types/vehicle";

interface Props {
  status: VehicleStatus;
  size?: "sm" | "md";
}

export function VehicleStatusBadge({ status, size = "sm" }: Props) {
  const config = vehicleStatusConfig[status];
  if (!config) return null;
  const Icon = config.icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-medium",
        config.bgColor, config.color,
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-xs"
      )}
    >
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {config.label}
    </span>
  );
}
